import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    ExternalItemLinkColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin country', 'originCountry'),
        new TextColumn('Destination country', 'destinationCountry'),
        new TextColumn('Mail serv. contr.', 'mailServiceContractor'),
        new ExternalItemLinkColumn(new TextColumn('Item ID', 'itemId')
          .withWidth(255)),
        new TextColumn('Sender', 'upu3CharSender'),
        new TextColumn('Receiver', 'upu3CharReceiver'),
        new DateTimeColumn('EMC event date', 'emcEventDate')
          .withWidth(150),
        new TextColumn('Outward OE', 'outwardOe'),
        new TextColumn('Despatch address', 'despatchAddress'),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId')
          .withWidth(255)),
        new TextColumn('Export flow origin', 'exportFlowOrigin'),
        new TextColumn('Item category', 'itemCategory'),
        new NonZeroNumberColumn('Item gross weight', 'itemGrossWeight'),
      ],
    },
  ];
};
